import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { TimeUtility } from 'utility-ts-type';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { APGenericSlotServant } from '../../../global/servants/ap_generic_slot_servant';
import { APGenericSlot, CourseSlot } from '../../builders/ap_generic_slot_builder';

class CourseLockDialogController {
  private genericSlot: APGenericSlot;
  private type: 'lock' | 'unlock';
  private dialogTitle: string;
  private dialogBodyText: string;
  private isOpened = true;
  constructor(
    private toggleLockCourseCommand: ICommand,
    private ngAPNotificationDelegate: INotificationDelegate,
    private $state: any,
    private ngAPTermsQuery: IQuery,
    private $element: ng.IAugmentedJQuery,
    private phxFocusDelegate: any,
    private phxAxReturnFocusFactory: any
  ) {}

  initialize() {
    this.dialogTitle = this.getTitleText();
    this.dialogBodyText = this.getBodyText();
  }

  $onChanges() {
    this.initialize();
  }

  $onInit() {
    this.initialize();
  }

  getTitleText() {
    let title = `${_4.capitalize(this.type)} ${_4.get(this.genericSlot, 'plannedCourse._course._title')}`;
    if (APGenericSlotServant.isCourseGroupSlot(this.genericSlot)) {
      title = `${title} ${this.type === 'lock' ? 'to' : 'from'} ${_4.get(this.genericSlot, 'programSlot.desc')}`;
    }
    return title;
  }

  getBodyText() {
    const termName = _4.get(_4.find(this.ngAPTermsQuery.result.plannedTerms, { id: this.genericSlot.termId }), 'name');
    const removalOfLock =
      this.type === 'lock' ? `This course will be automatically unlocked at the end of the ${termName} term.` : '';
    return `This course will be ${this.type}ed. They will ${this.type === 'lock' ? 'not' : ''}
      be able to move it from the term you assigned it to. ${removalOfLock}
      Are you sure you want to ${this.type} this course?`;
  }

  toggleLock() {
    this.toggleLockCourseCommand(_4.get(this.genericSlot, 'plannedCourse.id'), this.type === 'lock')
      .then(() => {
        this.closeDialog();
        this.ngAPNotificationDelegate.success(
          `${_4.get(this.genericSlot, 'plannedCourse._course._title')} is now ${this.type}ed`
        );
      })
      .catch(() => {
        this.ngAPNotificationDelegate.error(
          `Unable to ${this.type} ${_4.get(this.genericSlot, 'plannedCourse._course._title')}`
        );
      });
  }

  openedChanged() {
    this.$state.__goToPrevious__();
    this.phxFocusDelegate.focus(this.phxAxReturnFocusFactory.getFocusId());
  }

  closeDialog() {
    this.isOpened = false;
  }
}

class CourseLockDialog implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      type: '<',
      genericSlot: '<'
    };
    this.controller = CourseLockDialogController;
    this.templateUrl =
      'capability-ng-academic-planner/src/global/components/course_lock_dialog/course_lock_dialog.html';
  }
}
angular.module('capability-ng-academic-planner').component('courseLockDialog', new CourseLockDialog());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_lock_dialog/course_lock_dialog.ts